import {
  buildAppVersionFilterRows,
  buildCountryFilterView,
} from '../../resourceManage/genericResourceManage/genericResourceInfoHelper'

/** 分类 OS 版本对象 { start, end, skip } → 只读文案。 */
export function buildClassifyOsVersionText(versionObj) {
  if (!versionObj) {
    return '未配置'
  }
  const start = versionObj.start
  const end = versionObj.end
  const skip = versionObj.skip ? String(versionObj.skip).trim() : ''
  const hasStart = start !== '' && start != null
  const hasEnd = end !== '' && end != null
  if (!hasStart && !hasEnd && !skip) {
    return '未配置'
  }
  const parts = []
  if (hasStart || hasEnd) {
    parts.push(`${hasStart ? start : '—'} ~ ${hasEnd ? end : '—'}`)
  }
  if (skip) {
    parts.push(`跳过：${skip}`)
  }
  return parts.join('；')
}

function resolveDataSetName(dataSetId, dataOptions) {
  if (dataSetId === '' || dataSetId == null) {
    return ''
  }
  const match = (dataOptions || []).find(
    (item) => String(item.id) === String(dataSetId)
  )
  return match ? match.name : String(dataSetId)
}

/** 分类应用版本列表 → 与通用资源查看页相同表格行结构。 */
export function buildClassifyAppVersionRows(appVersion, dataOptions) {
  const rows = (appVersion || []).map((item) => ({
    start: item && item.start,
    end: item && item.end,
    skip: item && item.skip,
    dataSetId: item && item.dataSetId,
    dataSetName: resolveDataSetName(item && item.dataSetId, dataOptions),
  }))
  return buildAppVersionFilterRows(rows)
}

export function buildClassifyCountryView(country) {
  return buildCountryFilterView(country || { isExclude: true, countries: [] })
}

export function getClassifyStatusLabel(status) {
  return Number(status) === 1 ? '上线' : '下线'
}

export function getClassifyStatusVariant(status) {
  return Number(status) === 1 ? 'online' : 'offline'
}
